<template>
  <div>
    <div class="surequote-products__section">
        <div class="surequote-products__package " v-if="showPackageTypes" :class="'surequote-products__package--' + pack.Category.toLowerCase()">
            {{pack.Category}} Package
        </div>

        <span class="corner-ribbon top-left green shadow" v-if="showPackageTypes && pack.Category == 'Premium'">Most Popular</span>

        <img :src="pack.Image" class="surequote-products__image">

        <div class="surequote-products__price" v-if="!showFinanceOption">
            <span class="__currency">£</span>{{totalCost | currency}}
        </div>
        <div class="surequote-products__price" v-if="showFinanceOption">
            <span class="__currency">£</span>
            {{monthlyCostWithApr | currency}}
            <span class="surequote-products__month-tag">Per Month</span>
        </div>

        <div class="surequote-products__product-name">
            {{pack.ProductName}}
        </div>
        
        <!-- <div class="surequote-products__product-desc">
            {{pack.ProductDescription}}
        </div> -->

        <div class="surequote-products__warranty">
            {{pack.Warranty}} years warranty
        </div>

        <div class="surequote-products__request" v-if="showRequestButton && !TakeCustomerDetailsFirst">
            <!-- <router-link :to="{ name: 'Customer' }" tag="custom-button">User</router-link> -->
            <custom-button type="success" size="lg" animation="pulse" @click.native="selectPack(pack.Id)">Request a free Survey</custom-button>
        </div>
    </div>

    <div v-if="pack.ExtraProducts.length > 0">
        <div class="surequote-products__section">
            <div class="surequote-products__subtitle">
                Included Extras
            </div>
            <div class="surequote-products__extras">
                
                <div class="surequote-products__extras-item" v-for="(ex, i) in pack.ExtraProducts" :key="i">
                    <img :src="ex.Image" class="surequote-products__extras-image">
                    {{ex.ProductName}}
                </div>
            </div>
        </div>
    </div>

    <div class="surequote-products__includes">
        <div class="surequote-products__section">
            <custom-button type="default" size="lg" v-if="hasIncludes" @click.native="toggleIncludes()">View more details</custom-button>
            <div v-if="hasIncludes && showIncludes">
                <div class="surequote-products__subtitle">
                Includes
                </div>
                <p v-for="(inc, i) in pack.Includes" :key="i">
                    <img :src="getImage('yes')" class="">{{inc}}
                </p>  
            </div>
        </div>
     </div>
     
    <div class="surequote-products__section surequote_finance" v-if="UsesFinance">
        <h3 class="subtitle">Finance Options Available</h3>
        <custom-button v-if="UsesFinance && !showFinanceOption" type="warning" size="lg" @click.native="toggleFinance()">Monthly Payments</custom-button>
        <custom-button v-if="showFinanceOption" type="danger" size="lg" @click.native="toggleFinance()">I do not want finance</custom-button>
        <p>Subject to availability, pay an initial deposit and spread the payments up to {{maxFinancePeriodInYears}} years</p>
        <div v-if="showFinanceOption">
            <div class="surequote-products__subtitle">
                Finance Details
            </div>
            <finance-slider></finance-slider>
            <table class="sf__w-100 sf__table">
                <tbody>
                    <tr>
                        <td class="__sf-tl" :class="{'sf-green': interestFree}">APR Representative</td>
                        <td class="__sf-tr"><span v-if="interestFree"><strong class="sf-green">0%</strong></span><span v-else><strong>{{FinanceSettings.APR}}%</strong></span></td>
                    </tr>
                    <tr>
                        <td class="__sf-tl">Price</td>
                        <td class="__sf-tr"><strong>£{{totalCost | currency}}</strong></td>
                    </tr>
                    <tr>
                        <td class="__sf-tl">Your Deposit ({{FinanceSettings.Deposit}}%)</td>
                        <td class="__sf-tr"><strong>£{{deposit | currency }}</strong></td>
                    </tr>
                    <tr>
                        <td class="__sf-tl">Amount on finance</td>
                        <td class="__sf-tr"><strong>£{{amountOnFinance | currency}}</strong></td>
                    </tr>
                    <tr>
                        <td class="__sf-tl">Monthly Payment</td>
                        <td class="__sf-tr"><strong>£{{monthlyCostWithApr | currency}}</strong></td>
                    </tr>
                    <tr>
                        <td class="__sf-tl">Loan Duration</td>
                        <td class="__sf-tr"><strong>{{this.CalculatorSettings.selectedFinancePeriod / 12}} Years</strong></td>
                    </tr>
                    <tr>
                        <td class="__sf-tl">Total Amount Payable</td>
                        <td class="__sf-tr"><strong>£{{totalCostWithApr | currency}}</strong></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    
     
  </div>
</template>

<script>
import FinanceSlider from '@/components/FinanceSlider.vue';
import { mapGetters } from "vuex";
import { SELECT_PRODUCT_PACK } from '@/store/actions.type.js';

export default {
  name: 'product-package',
  data() {
      return {
          showIncludes: false, 
          showFinanceOption: false
      }
  },
  props: {
      pack: Object,
      isFinance: {
          type: Boolean,
          default: false
      },
      showPackageTypes: {
          type: Boolean,
          default: false
      },
      showRequestButton: {
          type: Boolean,
          default: true
      }
  },
  computed: {
      ...mapGetters(["FinanceSettings", "CalculatorSettings", "TakeCustomerDetailsFirst", "UsesFinance"]),
      totalCost() {
          return this.pack.TotalPrice.toFixed(2);
      },
      deposit() {
          return (this.pack.TotalPrice / 100 * this.FinanceSettings.Deposit).toFixed(2);
      },
      amountOnFinance() {
          return (this.totalCost - this.deposit).toFixed(2);
      },
      monthlyCostWithApr() {
        var p = this.pack.TotalPrice - this.deposit;
        var j = this.FinanceSettings.APR / 12 / 100;
        var n = this.CalculatorSettings.selectedFinancePeriod;
        if (n > this.FinanceSettings.FinanceInterestFreePeriod) {
            return (p * (j / (1 - (Math.pow((1 + j), (n * -1)))))).toFixed(2);
        } else {
            return (p / n).toFixed(2);
        }
      },
      totalCostWithApr() {
          return ((parseFloat(this.monthlyCostWithApr) * this.CalculatorSettings.selectedFinancePeriod) + parseFloat(this.deposit)).toFixed(2);
      },
      interestFree() {
          return this.CalculatorSettings.selectedFinancePeriod <= this.FinanceSettings.FinanceInterestFreePeriod;
      },
      hasIncludes() {
          return this.pack.Includes.length > 0;
      },
      maxFinancePeriodInYears(){
        return this.FinanceSettings.FinancePeriod / 12
      }
  },
  methods: {
        selectPack(id) {
            this.$store.dispatch(SELECT_PRODUCT_PACK, id);
            this.$router.push({ name: 'Customer' });
        },
        getImage(img) {
            return 'https://sf.surefiresoftware.co.uk/surequote2/front/img/' + img + '.svg'
        },
        toggleIncludes() {
            this.showIncludes = !this.showIncludes;
        },
        toggleFinance() {
            this.showFinanceOption = !this.showFinanceOption;
        }
  },
  components: {
    FinanceSlider
  }
}
</script>